import {getClassroomsWithStudents} from 'client/AdaptiveSubjects/AdaptiveSkillPath/getClassroomsWithStudents';

import {useAsyncRequest} from './useAsyncRequest';

const NO_NAMES: ReadonlyMap<string, string> = new Map();

/** The teacher's class names by id, archived classes included. */
export const loadClassroomNames = async (): Promise<ReadonlyMap<string, string>> =>
  new Map(
    (await getClassroomsWithStudents())
      .toArray()
      .map((classroom): [string, string] => [classroom.getId(), classroom.getName()])
  );

/** `loadClassroomNames` as a hook. Empty until they load. */
export const useClassroomNames = () => useAsyncRequest(loadClassroomNames, null).data ?? NO_NAMES;
